<template>
  <div
    class="modal-card field-select-model"
    style="width: 1200px; min-height: 400px"
  >
    <header class="modal-card-head">
      <p class="modal-card-title is-centered">更新訂單資訊</p>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <div class="columns">
          <div class="column is-6 has-text-centered has-text-weight-bold">
            <p class="is-size-4 is-bold">修改中資料</p>
          </div>
          <div class="column is-6 has-text-centered has-text-weight-bold">
            <p class="is-size-4 is-bold">正式報名資料</p>
          </div>
        </div>
        <div v-if="isLoading">
          <b-loading
            :is-full-page="false"
            :active="isLoading"
            :can-cancel="false"
          />
        </div>
        <div
          v-else
          v-for="(item, index) in details"
          :key="index"
          style="border: #69feff solid; padding: 4px 0; margin-bottom: 10px;"
        >
          <p class="has-text-centered is-size-5 has-text-weight-bold	">
            {{ `第${index + 1}位旅客` }}
          </p>
          <div class="columns">
            <div class="column is-6">
              <order-detail
                :origin-detail="item.temp"
                :reference-detail="item.formal"
                :common-questions="commonQuestions"
                :spot-questions="spotQuestions"
                :travelGroup="travelGroup"
                :first="index === 0"
                :disabled="false"
              />
            </div>
            <div class="column is-6">
              <order-detail
                :origin-detail="item.formal"
                :reference-detail="item.temp"
                :common-questions="commonQuestions"
                :spot-questions="spotQuestions"
                :travelGroup="travelGroup"
                :first="index === 0"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <div style="width: 100%">
        <div class="buttons is-right">
          <button class="button" type="button" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </button>
          <button
            class="button is-primary"
            :disabled="!canSave || isSending"
            @click.prevent="onSave"
          >
            {{ saveButtonName }}
          </button>
        </div>
      </div>
    </footer>
    <b-loading :is-full-page="true" :active="isSending" :can-cancel="false" />
  </div>
</template>

<script>
import { COLLABORATE_ORDERS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import OrderDetail from './OrderDetail'

export default {
  name: 'OrderUpdateForm',
  components: { OrderDetail },
  props: {
    orderNo: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      isSending: false,
      travelGroup: null,
      order: null,
      commonQuestions: [],
      spotQuestions: [],
      details: []
    }
  },
  computed: {
    canSave() {
      return (
        this.order &&
        (this.order.status === this.ORDER_STATUS.FILLING ||
          this.order.status === this.ORDER_STATUS.COMPLETED)
      )
    },
    saveButtonName() {
      if (this.order) {
        if (this.order.status === this.ORDER_STATUS.COMPLETED) {
          return '更新訂單'
        }
      }

      return '新增訂單'
    }
  },
  mounted() {
    this.loadOrder()
  },
  methods: {
    async loadOrder() {
      const api = `${COLLABORATE_ORDERS_API}/${this.orderNo}/compare`

      try {
        this.isLoading = true
        const res = await this.axios.get(api)
        this.order = res.data.data
        this.travelGroup = this.order.travel_group

        this.commonQuestions = this.travelGroup.common_questions
        this.spotQuestions = this.travelGroup.spot_questions
        this.details = this.order.temp_details.map(temp => {
          const formal = this.order.details.find(
            d => d.id === temp.formal_detail_id
          )

          return {
            temp,
            formal
          }
        })
      } catch (e) {
        notifyService.fetch_error('order', e)
      } finally {
        this.isLoading = false
      }
    },
    async onSave() {
      const api = `${COLLABORATE_ORDERS_API}/${this.orderNo}/update`

      try {
        this.isSending = true
        const res = await this.axios.put(api)

        this.order = res.data.data
        this.details = this.order.temp_details.map(temp => {
          const formal = this.order.details.find(
            d => d.id === temp.formal_detail_id
          )

          return {
            temp,
            formal
          }
        })

        notifyService.success('訂單更新成功')
        this.$emit('onComplete')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.isSending = false
      }
    }
  }
}
</script>
